import { useEffect, useState } from "react";
import { msalInstance } from "authConfig";
import { GetAccessToken } from "utils/access-token";

const AppInitializer = ({ children }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        await msalInstance.initialize();
        const response = await msalInstance.handleRedirectPromise();

        if (response !== null) {
          msalInstance.setActiveAccount(response.account);
        }
        await GetAccessToken(msalInstance);

        setReady(true);
      } catch (err) {
        console.error("MSAL Init Error:", err);
      }
    };

    init();
  }, []);

  if (!ready) return null;

  return children;
};

export default AppInitializer;
